<template>
  <BtnFlotWA />
  <section> <Navbar /> </section>

  <!-- Banners -->
  <section class="brand-header-section" v-if="currentBrandData">
    <div class="brand-banner-container">
      <img class="bannerestatico" :src="currentBrandData.banner" :alt="currentBrandData.name" />
    </div>
  </section>

  <section class="catalog-container">
    <aside class="sidebar">
      <!-- CATEGORÍAS EN SIDEBAR -->
      <div class="filter-section">
        <h4 class="h4"> CATEGORIAS </h4>
        <label v-for="cat in categories" :key="cat">
          <input type="radio" :value="cat" v-model="selectedCategory" /> {{ cat }}
        </label>
      </div>
      <!-- DISPONIBILIDAD -->
      <div class="filter-section">
        <h4 class="h4">DISPONIBILIDAD</h4>
        <label><input type="radio" value="all" v-model="stockFilter"> Todos </label>
        <label><input type="radio" value="inStock" v-model="stockFilter"> Stock </label>
        <label><input type="radio" value="outStock" v-model="stockFilter"> Pre-orden</label>
      </div>
    </aside>

    <main class="catalog-content mobile-category-wrapper">
      <div class="contenedor-grid">
        <div class="columna">
          <div class="mobile-filters-top">
            <button class="mobile-category-button" @click="filtersOpen = !filtersOpen" :aria-expanded="filtersOpen"> 
              <span class="category-button-left"> 
                <span class="pCategory">Categorías</span> 
              </span>
              <span class="category-button-right"> 
                <span v-if="selectedCategory !== 'Todos'" class="selected-category-name"> -- {{ selectedCategory }} </span> 
                <span class="category-chevron" :class="{ open: filtersOpen }"> ⌄ </span> 
              </span> 
            </button>

            <!-- Dropdown cel --> 
            <transition name="category-dropdown"> 
              <div v-if="filtersOpen" class="mobile-category-dropdown"> 
                <div class="category-dropdown-header"> 
                  <span> </span> 
                  <button class="category-dropdown-close" @click="closeMobileFilters" aria-label="Cerrar categorías"> X </button> 
                </div>  

                <div class="mobile-category-chips"> 
                  <button v-for="category in categories" :key="category" 
                    type="button" class="mobile-category-chip" 
                    :class="{ active: selectedCategory === category }" 
                    @click="selectMobileCategory(category)"> 
                    {{ category }} 
                  </button> 
                </div>  
                <div class="mobile-stock-section"> 
                  <span class="stock-title"> Disponibilidad </span> 
                  <div class="mobile-stock-chips"> 
                    <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'all' }" @click="stockFilter = 'all'"> Todos </button> 
                    <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'inStock' }" @click="stockFilter = 'inStock'"> En stock </button> 
                    <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'outStock' }" @click="stockFilter = 'outStock'"> Pre-orden </button> 
                  </div> 
                </div> 

                <div v-if="selectedCategory !== 'Todos' || stockFilter !== 'all' || selectedBrand !== 'Todas'" class="mobile-category-footer"> 
                  <button type="button" class="mobile-clear-button" @click="clearFilters"> 
                    Limpiar filtros 
                  </button> 
                </div> 
              </div> 
            </transition>
          </div>
        </div>
      </div>

      <div class="columna">
          <div class="search-wrapper">
            <div class="search-bar">
              <span class="search-icon"> 🔍 </span>
                <input type="text" v-model="searchQuery" placeholder="¿Qué estas buscando...?" />
                  <button v-if="searchQuery" class="clear-search" type="button" @click="searchQuery = ''" aria-label="Limpiar búsqueda" > × </button> 
            </div>
            <div class="quick-search">
              <p>Busca por:</p>
                <button @click="searchQuery='Skin1004'"> Skin1004 </button>
                <button @click="searchQuery='Mini'"> Mini </button>
                <button @click="searchQuery='Niacinamida'"> Niacinamida </button>
                <button @click="searchQuery='Rhode'"> Rhode </button>
            </div>
          </div>
        </div>



      <div class="toolbar">
        <p> Mostrando {{ filteredProducts.length ? (currentPage - 1) * productsPerPage + 1 : 0 }} -
            {{ Math.min(currentPage * productsPerPage, filteredProducts.length) }}
            de {{ filteredProducts.length }} productos
        </p> 
        
        <div class="sort">
          <p class="titSort">Ordenar por:</p>
          <select v-model="sortOption">
            <option value="Todos">Todos</option>
            <option value="Menor Precio">Menor Precio</option>
            <option value="Mayor Precio">Mayor Precio</option>
          </select>
        </div>
      </div>

      <!-- GRID Y CARDS -->
      <div class="product-grid">
        <div class="card-catal" 
          v-for="product in paginatedProducts" 
          :key="`${product.id}-${product.categorySource || 'item'}`" >

          <!-- CHIP DE STOCK -->
          <span class="badge stock" :class="{ out: !product.stock }">
            {{ product.stock ? 'Disponible' : 'Pre-orden' }}
          </span>

          <!-- GALERÍA DE IMÁGENES -->
          <div class="product-gallery">
            <img class="main-product-image" 
              :src="selectedImages[product.id] || product.image" 
              :alt="product.name" />
          </div>

          <!-- ENCABEZADO DE LA CARD -->
          <div class="card-content">
            <small class="category">{{ product.brand }}</small>
            <div class="title-row">
              <h3>{{ product.name }}</h3>
              <span class="price">
                ${{ product.tam?.length ? (selectedSize[product.id]?.price || product.tam[0]?.price) : product.price }}
              </span>
            </div>
          </div>

          <!-- SKINCARE INFO -->
          <div class="skincare-info">
            <div class="title-row" style="margin-bottom: 5px;">
              <p class="shade-count" v-if="product.routine"> 
                <span>{{ product.routine }}</span> 
              </p>
            </div>
            <div v-if="product.skinType?.length">
              <div class="no-tags">
                <p class="perfume-type">Para piel:</p>
                <span v-for="type in product.skinType" :key="type">{{ type }}</span>
              </div>
            </div>
            <div v-if="product.concerns?.length">
              <p class="perfume-type" style="margin-bottom: 1px;">Ideal para:</p>
              <div class="notes-tags">
                <span v-for="concern in product.concerns" :key="concern"> {{ concern }} </span>
              </div>
            </div>

            <!-- SELECCIÓN DE TAMAÑOS CON CAMBIO DE IMAGEN -->
            <div v-if="product.tam?.length" style="margin-top: 10px; margin-bottom: 15px;">
              <p class="perfume-type">Tamaños disponibles:</p>
              <div class="sizes-wrapper">
                <button v-for="size in product.tam" :key="size.ml" 
                  class="size-btn"
                  :class="{ active: selectedSize[product.id]?.ml === size.ml }"
                  @click="selectSize(product.id, size, product)"> 
                  {{ size.ml }}ml
                </button>
              </div>
            </div>

            <button class="order-btn" @click="makeOrder(product)" :class="{ preorder: !product.stock }">
              {{ product.stock ? 'Pedir ahora' : 'Pre-ordena' }}
            </button>
          </div>

        </div>
      </div>

      <div class="pagination" v-if="totalPages > 1">
        <button @click="prevPage" :disabled="currentPage === 1"> ❮ </button>
        <button v-for="page in totalPages" :key="page" @click="currentPage = page" :class="{ active: currentPage === page }">
          {{ page }}
        </button>
        <button @click="nextPage" :disabled="currentPage === totalPages" style="font-weight:600;">
          ❯
        </button>
      </div>
    </main>
  </section>

  <section style="padding-top: 0px;">
    <Footer />
  </section>
</template>

<script setup>
import '@/styles/catalogo.css'
import { computed, ref, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { products as skincareProducts } from '@/data/skincare';

import BtnFlotWA from '@/components/BtnFlotWA.vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import skin1004 from '@/assets/brandslogos/skin1004.svg';

const route = useRoute()
const router = useRouter()

const phoneNumber = '522283616313'

const brandBanners = {
  'Todas': '/banners/explora.png',
  'Rhode': '/banners/rhode.png',
  'Summer': '/banners/summer.png',
}

const featuredBrands = ref([
  { name: 'Todas' },
  { name: 'Rhode' },
  { name: 'Summer' },
]);

const isBrandModalOpen = ref(false)
const modalBrandSearch = ref('')
const selectedLetter = ref('ALL')

const selectedBrand = ref('Todas')
const selectedCategory = ref('Todos')
const stockFilter = ref('all')
const sortOption = ref('Todos')
const searchQuery = ref('')

const selectedImages = ref({})
const selectedSize = ref({})

const categories = [
  'Todos',
  'Limpiadores',
  'Sérums',
  'Hidratantes',
  'Protectores Solares'
]

const currentPage = ref(1)
const productsPerPage = 30

const allRawProducts = computed(() => {
  return Array.isArray(skincareProducts) ? skincareProducts.map(p => ({ ...p, categorySource: 'skincare' })) : [];
});

const allBrandsList = computed(() => {
  const brandsSet = new Set()
  allRawProducts.value.forEach(p => {
    if (p.brand && p.brand.trim()) {
      brandsSet.add(p.brand.trim())
    }
  })
  return ['Todas', ...Array.from(brandsSet).sort((a, b) => a.localeCompare(b))]
})

const formatBrandForUrl = (name) => {
  return name.toLowerCase().replace(/\s+/g, '-');
}

const getBrandFromUrl = (urlBrand) => {
  if (!urlBrand) return 'Todas';
  const found = allBrandsList.value.find(b => formatBrandForUrl(b) === urlBrand);
  return found || 'Todas';
}

onMounted(() => {
  if (route.params.marca) {
    selectedBrand.value = getBrandFromUrl(route.params.marca);
  }
})

// MÉTODO PARA SELECCIONAR TAMAÑO Y CAMBIAR IMAGEN
const selectSize = (productId, sizeObj, product) => {
  selectedSize.value[productId] = sizeObj
  if (sizeObj.image) {
    selectedImages.value[productId] = sizeObj.image
  } else {
    selectedImages.value[productId] = product.image
  }
}

const selectBrand = (brandName) => {
  selectedBrand.value = brandName
  isBrandModalOpen.value = false

  if (brandName === 'Todas') {
    router.push({ path: '/Marcas' })
  } else {
    router.push({ path: `/Marcas/${formatBrandForUrl(brandName)}` })
  }
}

const currentBrandData = computed(() => {
  const brandName = selectedBrand.value;
  const bannerPath = brandBanners[brandName] || brandBanners['Todas'];
  
  return {
    name: brandName,
    banner: bannerPath
  };
});

const availableLetters = computed(() => {
  const letters = new Set()
  allBrandsList.value.forEach(b => {
    if (b !== 'Todas') {
      const firstChar = b.charAt(0).toUpperCase()
      if (/[A-Z]/.test(firstChar)) {
        letters.add(firstChar)
      }
    }
  })
  return Array.from(letters).sort()
})

const modalFilteredBrands = computed(() => {
  return allBrandsList.value.filter(b => {
    const matchesSearch = b.toLowerCase().includes(modalBrandSearch.value.toLowerCase().trim())
    const matchesLetter = selectedLetter.value === 'ALL' || b.toUpperCase().startsWith(selectedLetter.value)
    return matchesSearch && matchesLetter
  })
})

const getProductPrice = (p) => {
  if (p.tam?.length) {
    return selectedSize.value[p.id]?.price || p.tam[0]?.price || 0;
  }
  return p.price || 0;
};

const filteredProducts = computed(() => {
  let filtered = [...allRawProducts.value]

  if (selectedBrand.value !== 'Todas') {
    filtered = filtered.filter(p => p.brand && p.brand.trim().toLowerCase() === selectedBrand.value.trim().toLowerCase())
  }

  const search = searchQuery.value.toLowerCase().trim()
  if (search) {
    const words = search.split(/\s+/)
    filtered = filtered.filter(product => {
      const searchableText = [ 
        product.name, 
        product.brand, 
        product.category
      ].join(' ').toLowerCase()
      return words.every(word => searchableText.includes(word))
    })
  }

  if (selectedCategory.value !== 'Todos' && !searchQuery.value.trim()) {
    filtered = filtered.filter(product => product.category === selectedCategory.value)
  } 

  if (stockFilter.value === 'inStock') {
    filtered = filtered.filter(product => product.stock)
  }
  if (stockFilter.value === 'outStock') {
    filtered = filtered.filter(product => !product.stock)
  }

  if (sortOption.value === 'Menor Precio') {
    filtered.sort((a, b) => getProductPrice(a) - getProductPrice(b))
  }
  if (sortOption.value === 'Mayor Precio') {
    filtered.sort((a, b) => getProductPrice(b) - getProductPrice(a))
  }

  return filtered
})

const totalPages = computed(() => Math.ceil(filteredProducts.value.length / productsPerPage))

const paginatedProducts = computed(() => {
  const start = (currentPage.value - 1) * productsPerPage
  return filteredProducts.value.slice(start, start + productsPerPage)
})

const filtersOpen = ref(false)

const closeMobileFilters = () => {
  filtersOpen.value = false
}

const selectMobileCategory = (category) => {
  selectedCategory.value = category
  searchQuery.value = '' 
  filtersOpen.value = false
}

const clearFilters = () => {
  selectedBrand.value = 'Todas'
  selectedCategory.value = 'Todos'
  stockFilter.value = 'all'
  searchQuery.value = ''
  router.push({ path: '/Marcas' })
}

watch([selectedBrand, selectedCategory, stockFilter, sortOption, searchQuery], () => {
  currentPage.value = 1
})

const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++
}

const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--
}
</script>